<template>
  <section>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-6 is-offset-3 stepbar-padding">
          <div class="lc-intro-block">
            <h3 class="intro">Perfect, time to know a little about the product you want to produce on-demand.</h3>
          </div>
          <form
            @submit.prevent="onSubmit"
          >
            <b-field
              horizontal
              label="I would like to:"
              class="lc-field lc-existing-product"
            >
              <b-radio-button v-model="form.existingProduct"
                :native-value="false"
                class="lc-radio"
                @input="emitValidate"
              >
                <span>create a <span class="is-hidden-mobile">new</span> product</span>
              </b-radio-button>

              <b-radio-button v-model="form.existingProduct"
                :native-value="true"
                class="lc-radio"
                @input="emitValidate"
              >
                <span>scale <span class="is-hidden-tablet">a </span><span class="is-hidden-mobile">an existing</span> product</span>
              </b-radio-button>
            </b-field>
            <b-field
              horizontal
              label="Market Location"
              class="lc-field"
            >
              <LCDropdownInput
                v-model="form.marketLocation"
                :options="['Asia', 'Americas', 'Europe', 'Africa']"
                placeholder="select"
                @input="emitValidate"
              />
            </b-field>
            <b-field
              horizontal
              label="my design status"
              class="lc-field"
            >
              <LCDropdownInput
                v-model="form.designStatus"
                :options="['sketch', 'tech draw', '3D']"
                placeholder="select"
                @input="emitValidate"
              />
            </b-field>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import LCDropdownInput from '@/components/leads_catcher/LCDropdownInput.vue'

  export default {
    name: 'Market',
    components: {
      LCDropdownInput
    },
    props: {
      form: Object
    },
    mounted() {
      this.emitValidate()
    },
    methods: {
      validate() {
        // return true
        return (this.form.existingProduct != undefined &&
                this.form.marketLocation != '' &&
                this.form.designStatus != '')
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      }
    }
  }
</script>

<style lang="scss" scoped>
.lc-existing-product /deep/ .field-body {
  display: flex;
  clear: both;
  justify-content: space-between;

  @media screen and (min-width: $tablet) {
    clear: none;
  }
}
</style>
